export const moverCoupons = ["WW2MF", "MOVERS2MF", "BPD2MF"];
export const isMoverCoupon = (code: string) => moverCoupons.indexOf(code) !== -1;
